export const STAGE = {
  local: "local",
  dev: "dev",
  test: "test",
  acc: "acc",
  stg: "stg",
  prod: "prod",
  live: "live",
} as const;
